import { dispatchSetConnectionStatus } from '../../components/main/root.action'

export default () => dispatchSetConnectionStatus('authenticating')
